export default {
  REVALIDATE_EMAIL_REQUESTED: 'REVALIDATE_EMAIL_REQUESTED',
  REVALIDATE_EMAIL_SUCCEEDED: 'REVALIDATE_EMAIL_SUCCEEDED',
  REVALIDATE_EMAIL_FAILED: 'REVALIDATE_EMAIL_FAILED',
};
